module.exports = __webpack_public_path__ + "static/media/step-indicator-3.a6b3328d.svg";